
<label class="form-label">{{to?.label}} <span *ngIf="to?.required" class="text-danger me-2">*</span> <span class="question" placement="end" [ngbTooltip]="to?.tooltip">
    <img width="18" src="https://foreign-admits-s3-bucket-public.s3.ap-south-1.amazonaws.com/website-cms/1708337509463info-circle.png" alt="infononcollateral"></span></label>

<div>
    <input [required]="to?.required" [formControl]="formControl" class="form-control" type="text"  [placeholder]="to.placeholder">
</div>